export const calculaTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const secondsRemain = Math.floor(seconds % 60);

  const returnedMinutes = `${minutes.toString().padStart(2, "0")}`;
  const returnedSeconds = `${secondsRemain.toString().padStart(2, "0")}`;

  return `${returnedMinutes}:${returnedSeconds}`;
};
